import React from "react";
import { useState } from "react";
import logoschool from "../../assets/images/logosignup.png";
import logomain from "../../assets/images/logomain.png";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { toast } from "react-toastify";
import useThrottledClick from "../../hooks/useThrottledClick";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import {
  checkAndBlockIfTrialExpired,
  verifySchoolSubscriptionBlocked,
} from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";

const ForgetPassword = () => {
  const { signupData } = React.useContext(SchoolSignupContext);
  const [, setLoading] = useState(false);
  const location = useLocation()
  const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");

  const [, setError] = useState(false);
  const navigate = useNavigate();
  const email = location.state?.email;
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [, setErrorMsg] = useState("");
  const {
    showTrialExpiredModal,
    setShowTrialExpiredModal,
    handleTrialRenew,
    handleTrialCancel,
    cancelLoading,
  } = useTrialExpiredModal(signupData);

  async function decodeJWT(token) {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  }

 const callTokenRefresh = async (token) => {
    try {
      const response = await fetch(
        `${baseURL}/user/tokenRefresh?masterTypeid=${schoolType?schoolType:""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
	  return data; // 👈 MUST return data
    } catch (error) {
      console.error("❌ Error calling tokenRefresh API:", error);
    }
  };
  const handleUpdateSchool = async (user_Id,decodedTokenOld) => {
    const apiUrl = `${baseURL}/school/updateSchool`;
    // const apiUrl = `http://localhost:8000/api/v1/school/updateSchool`;
    const data = {
      // schoolId: String(signupData.schoolId),
      // userId: user_Id,
      // schoolName: signupData.schoolName,
      // code: signupData.schoolCode,
      schoolId: String(signupData.schoolId),
      userId: String(user_Id),
      schoolName: String(signupData.schoolName),
      code: String(signupData.schoolCode),
      masterTypeid: schoolType ? schoolType : "",
    };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });




      const schoolContext = {
        ...signupData,
        schoolCode: signupData.schoolCode ?? signupData.verificationCode,
      };

      if (
        checkAndBlockIfTrialExpired(response.data, schoolContext) ||
        (response.data.code === 200 &&
          (await verifySchoolSubscriptionBlocked(baseURL, schoolContext)))
      ) {
        localStorage.removeItem("access_token");
        setShowTrialExpiredModal(true);
        return;
      }

      if (response.data.code === 200) {
         let refreshToken= await callTokenRefresh(decodedTokenOld);
		localStorage.setItem("access_token", refreshToken?.data);
  
		// Decode token
		const decodedToken = await decodeJWT(refreshToken?.data);
		console.log("decodedToken",decodedToken)
		const userId = decodedToken.user_id;
		const masterTypeid = decodedToken.masterTypeid;
		console.log("userId",userId)
		// if(userId==367 || 222){
			if(masterTypeid === 1){
	
		 console.log("userId id is persent",userId)
		localStorage.setItem("school_type", "tft");
				 window.location.href = "/";
                //  navigate("/", { state: { email } });
                //  window.location.reload(); // refresh the page




		}else{
			console.log("userId not tft id is persent",userId)

		localStorage.setItem("school_type","");
				 window.location.href = "/";
                //  navigate("/", { state: { email } });
                //  window.location.reload(); // refresh the page



		}


        // Handle success (e.g., navigate to another page)
      }
      else {
        if (checkAndBlockIfTrialExpired(response.data, schoolContext)) {
          localStorage.removeItem("access_token");
          setShowTrialExpiredModal(true);
          return;
        }
        localStorage.removeItem("access_token");
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        // Server responded with an error status code
        toast.error(`❌ Error: ${error.response.data.message || 'Update failed'}`);
        console.error('Error Response:', error.response.data);
      } else {
        // Network error or no response
        toast.error('❌ Network error!');
        console.error('Error:', error.message);
      }
    }
  };


  //  const Code = location.state?.Code;
  const [code, setCode] = useState("");

  const goToProfile = async () => {
    await new Promise(res => setTimeout(res, 1000));


    if (code === "") {
      setErrorMsg("The verification code is required");
    }
    else {
      try {
        setLoading(true)
        const response = await axios.post(`${baseURL}/user/verifyOTP`, {
          email: email,
          code: code.toString(),
          masterTypeid:schoolType?schoolType:"",

        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setLoading(false)

        if (response.data.code === 200) {
          toast.success(response.data.message)
        }
        else {
          toast.error(response.data.message)

        }
        if (response.data.code !== 400) {
          localStorage.setItem("access_token", response.data?.data);
          const decodedToken = await decodeJWT(response.data?.data);
          const userId = decodedToken.user_id;
          await handleUpdateSchool(userId,response.data?.data)
        }
        else {
          setError(true)
        }
      } catch (error) {
        setLoading(false)
        console.log("error")
        // console.error('Error creating user:', error.response ? error.response.data : error.message);
      }
    }
  };

  const ResendCode = async () => {
    await new Promise(res => setTimeout(res, 1000));

    try {
      setLoading(true)
      const response = await axios.post(`${baseURL}/user/resentOTP`, {
        email: email
      },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        });

      setLoading(false)
      if (response.data.code === 200) {
        toast.success(response.data.message)
      }
      // alert("Message sent successfully.")
    } catch (error) {
      setLoading(false)
      console.log("error")
      // console.error('Error creating user:', error.response ? error.response.data : error.message);
    }
  };


  const [throttledContinue, isLoading] = useThrottledClick(goToProfile, 3000);
  const [throttledResend, isLoadingResend] = useThrottledClick(ResendCode, 3000);


  return (<>
    <TrialExpiredModal
      open={showTrialExpiredModal}
      onActivatePlan={handleTrialRenew}
      onCancelSubscription={handleTrialCancel}
      cancelLoading={cancelLoading}
    />

    <div className="school-pages-inner">
      <div className="school-content-page">
        {/* <img src={logoschool}/>  */}
        {schoolType === 1 ? <img src={logomain}
          alt="School Logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/school")}
        /> :  
        <img
          src={logoschool}
          alt="School Logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/school")}
        />}
        <div className="schoo-outer">
          <div className="school-outer-pages forget-passw">
            <h2>Email Verification Required</h2>

            <p className="verification-code">
              Your email address has not yet been verified. Please enter the verification code sent to{" "}
              {email || "your email"} to activate your account and continue.
            </p>
            <p className="verification-code" style={{ marginTop: 8 }}>
              If you don’t see the email, please check your spam or junk folder. You can also request a new verification code below.
            </p>

            <div className="input-container">
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder=" "
              />
              <label >Verification Code</label>

            </div>

            <button className="continue-btn"
              // onClick={goToProfile}
              onClick={throttledContinue}
            >
              {isLoading ? '⏳ VERIFYING...' : 'Verify Email'}
            </button>

            <button className="continue-btn"
              // onClick={goToProfile}
              onClick={throttledResend}
            >
              {isLoadingResend ? '⏳ SENDING...' : 'Resend Code'}
            </button>

            <p className="login-account" onClick={() => {
                if (location.state?.fromLogin) {
                  navigate("/login-password", { state: { email } });
                } else {
                  navigate("/school");
                }
              }}
              style={{ cursor: 'pointer' }}

            >{location.state?.fromLogin ? "Back to Login" : "Back to Sign Up"}</p>

            <p className="term-part" >
              <a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
            </p>
          </div>

        </div>

      </div>

    </div>



  </>);

}
export default ForgetPassword;